import { ShieldAlert } from 'lucide-react'
import { Button, Modal } from '../ui'

interface MfaSetupWizardProps {
  isOpen: boolean
  onOpenSecuritySettings: () => void
  onLogout: () => void
}

export default function MfaSetupWizard({ isOpen, onOpenSecuritySettings, onLogout }: MfaSetupWizardProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      closeOnBackdrop={false}
      title="2FA erforderlich"
      footer={
        <div className="flex items-center justify-end gap-2">
          <Button variant="outline" onClick={onLogout}>
            Abmelden
          </Button>
          <Button onClick={onOpenSecuritySettings}>Jetzt einrichten</Button>
        </div>
      }
    >
      <div className="space-y-3">
        <div className="flex items-center gap-2 text-primary-700 dark:text-primary-300">
          <ShieldAlert className="h-5 w-5" />
          <p className="font-medium">Ihr Konto braucht jetzt einen zweiten Faktor.</p>
        </div>
        <p className="text-sm text-gray-700 dark:text-gray-300">
          Fuer diese Rolle ist Zwei-Faktor-Authentifizierung verpflichtend. Bitte richte jetzt
          FreeOTP oder E-Mail-Code ein und speichere danach Wiederherstellungscodes.
        </p>
      </div>
    </Modal>
  )
}
